"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var TOGGLE_WIDTH = 32;
var TOGGLE_HEIGHT = 20;
var THUMB_DIAMETER = 14;
var FOCUS_WIDTH = 3;
exports.createMuiSwitchOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing, transitions = _a.transitions;
    return ({
        root: {
            width: TOGGLE_WIDTH,
            height: TOGGLE_HEIGHT,
            margin: spacing(2),
            overflow: undefined,
            padding: undefined,
        },
        input: {
            left: 0,
            width: "100%",
            height: "100%",
        },
        switchBase: {
            top: spacing(-2),
            left: spacing(-2),
            padding: TOGGLE_HEIGHT - THUMB_DIAMETER / 2,
            borderRadius: "50%",
            transition: transitions.create(["left", "transform", "background-color"], {
                duration: transitions.duration.shortest,
            }),
            "&$checked": {
                transform: "translateX(" + (TOGGLE_WIDTH -
                    FOCUS_WIDTH * 2 -
                    THUMB_DIAMETER) + "px)",
            },
            "&$checked + $track": {
                opacity: undefined,
            },
            "&$disabled": {
                opacity: palette.action.disabledOpacity,
            },
            "&$disabled + $track": {
                opacity: palette.action.disabledOpacity,
            },
        },
        colorPrimary: {
            "&$switchBase": {
                color: palette.common.white,
                "&:hover, &.Mui-focusVisible": {
                    backgroundColor: palette.action.hover,
                },
                "&$disabled": {
                    color: palette.common.white,
                },
                "&:active, &&$checked:active": {
                    backgroundColor: styles_1.fade(palette.text.primary, 0.24),
                },
            },
            "&$checked": {
                color: undefined,
                "&:hover": {
                    backgroundColor: undefined,
                },
            },
            "&$disabled": {
                color: undefined,
            },
            "& + $track": {
                backgroundColor: palette.dividerStrong,
            },
            "&$disabled + $track": {
                backgroundColor: undefined,
            },
        },
        thumb: {
            width: THUMB_DIAMETER,
            height: THUMB_DIAMETER,
            boxShadow: undefined,
        },
        track: {
            borderRadius: TOGGLE_HEIGHT / 2,
            opacity: undefined,
        },
        // TODO: Update when VDL has designs for "small". Without this, setting it to small will use default styles
        sizeSmall: {
            width: undefined,
            height: undefined,
            padding: undefined,
            "& $thumb": {
                width: undefined,
                height: undefined,
            },
            "& $switchBase": {
                padding: undefined,
                "&$checked": {
                    transform: undefined,
                },
            },
        },
    });
};
//# sourceMappingURL=MuiSwitch.js.map